import React, { useEffect, useRef, useState } from 'react';
import { useGesture } from 'react-use-gesture';
import { ZoomComponent, ChildContainer, ChildComponent, ZoomContainer, ZoomButton } from './style';
const DEFAULT_ZOOM_STEP = 0.5;
const DEFAULT_MIN_SCALE = 1;
const DEFAULT_MAX_SCALE = 5;
export const ZoomWrapper = ({ id, scale = DEFAULT_MIN_SCALE, step = DEFAULT_ZOOM_STEP, minScale = DEFAULT_MIN_SCALE, maxScale = DEFAULT_MAX_SCALE, showZoomIcon = true, gestureEnabled = true, transformEnabled = true, centerContent = true, style, children, onZoomChange, className, panOffset = [0, 0] }) => {
    const domTarget = useRef(null);
    const [coordinateX, setCoordinateX] = useState(0);
    const [coordinateY, setCoordinateY] = useState(0);
    const transformStyle = {
        WebkitTransform: `translate3d(${coordinateX + panOffset[0]}px, ${coordinateY +
            panOffset[1]}px, 0px) scale(${scale})`,
        transform: `translate3d(${coordinateX + panOffset[0]}px, ${coordinateY +
            panOffset[1]}px, 0px) scale(${scale})`
    };
    /* istanbul ignore next */
    const gestureHandler = useGesture({
        onDrag: ({ down, movement: [coordinateX, coordinateY] }) => {
            setCoordinateX(down ? coordinateX : 0);
            setCoordinateY(down ? coordinateY : 0);
        },
        onWheel: ({ movement }) => {
            movement[1] < 0
                ? onZoomChange(Math.max(Math.min(scale + step, maxScale), minScale))
                : onZoomChange(Math.max(Math.min(scale - step, maxScale), minScale));
        }
    }, { domTarget, drag: { initial: () => [0, 0] }, enabled: gestureEnabled });
    useEffect(gestureHandler, [gestureHandler]);
    const onZoomInHandler = () => {
        if (!(scale >= maxScale)) {
            onZoomChange(Math.max(Math.min(scale + step, maxScale), minScale));
        }
    };
    const onZoomOutHandler = () => {
        if (scale > minScale) {
            onZoomChange(Math.max(Math.min(scale - step, maxScale), minScale));
        }
    };
    const renderZoomIcon = () => showZoomIcon ? (React.createElement(ZoomContainer, { id: `zoom-container-${id}`, style: style },
        React.createElement(ZoomButton, { className: "mi-icon-zoom-in", onClick: onZoomInHandler, disabled: scale === maxScale }),
        React.createElement(ZoomButton, { className: "mi-icon-zoom-out", onClick: onZoomOutHandler, disabled: scale === minScale }))) : null;
    return (React.createElement(ZoomComponent, { id: `zoom-component-${id}`, className: className },
        React.createElement(ChildContainer, { id: `child-container-${id}`, ref: domTarget, centerContent: centerContent },
            React.createElement(ChildComponent, { id: `child-component-${id}`, style: transformEnabled ? transformStyle : undefined }, children)),
        renderZoomIcon()));
};
//# sourceMappingURL=ZoomWrapper.js.map